// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Ig3Hd","button__icon":"Button_button__icon__Jm0qq","buttonFullWidth":"Button_button--fullWidth__jTCqd"};